import { useState } from 'react';
import './contact.css';
import LoadingScreen from './../utils/LoadingScreen';
import { Email, WhatsApp, LocationOn } from '@mui/icons-material';

const Contact = () => {
    const [mapLoaded, setMapLoaded] = useState(false);

    return (
        <section className="font-raleway bg-neutral-100 py-5 text-black1" id='contactUs'>
            <h1 className="heading text-3xl md:text-5xl font-bold text-darkGreen1">Contact Us</h1>
            <div className="location-container relative">
                {!mapLoaded && <LoadingScreen />}
                <iframe
                    src="https://www.google.com/maps?q=13.023195%2C+79.324752&z=15&t=m&hl=en&output=embed"
                    width="100%"
                    height={mapLoaded ? '450' : '0'}
                    style={{ border: 0 }}
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Kalikosh Carbon India Pvt. Ltd."
                    onLoad={() => setMapLoaded(true)}
                ></iframe>
            </div>
            <div className="contact-details-container mb-8">
                <h2 className="sub-heading text-2xl text-center text-green1 font-bold mb-4">Contact Details</h2>
                <div className="contact-details-grid">
                    <div className="contact-details-item email text-center" onClick={() => window.location.href = 'mailto:info@kalikosh.com'}>
                        <div className="contact-info">
                            <Email className="contact-icon" />
                            <span>info@kalikosh.com</span>
                        </div>
                    </div>
                    <div className="contact-details-item whatsapp text-center" onClick={() => window.location.href = 'https://wa.me/message/KX2ZWVDBMWOHM1'}>
                        <div className="contact-info">
                            <WhatsApp className="contact-icon" />
                            <span>+91 63612 37564</span>
                        </div>
                    </div>
                    <div className="contact-details-item address text-center">
                        <div className="contact-info">
                            <LocationOn className="contact-icon" />
                            <span>Plot No 185/4b, Katharikuppam Village, Walaja Taluk, Ranipet District, Tamil Nadu 632405</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
